// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datos-vehiculo-list {
  max-height: 60vh;
  min-height: 30vh;
  height: -moz-fit-content;
  height: fit-content;
  overflow-y: scroll;
}

.datos-vehiculo,
.datos-fav {
  display: flex;
}

.datos-matricula,
.datos-nom-gas,
.datos-nom-user,
.datos-nom-user-empty {
  font-weight: 600;
}

.datos-nom-user {
  text-transform: capitalize;
}

.datos-nom-user-empty {
  text-align: center;
}

.datos-matricula {
  text-transform: uppercase;
}

.datos-tipo-vehiculo,
.datos-dir-gas,
.datos-dni-user {
  color: #a098ae;
}

.datos-prov-gas {
  font-weight: 700;
}

.datos-start,
.datos-content,
.datos-end {
  align-items: center;
  /* background-color: #fdf4f4; */
  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);
  display: flex;
  padding: 0.8em;
  min-width: 7em;
}

.datos-start,
.datos-gas {
  border-radius: 20px 0 0 20px;
  display: block;
}

.datos-gas {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.datos-end {
  border-radius: 0 20px 20px 0;
}

.datos-mas-btns {
  display: none;
}

.edit-icon-btn {
  width: 23px;
  height: 23px;
}

.delete-icon-btn {
  width: 20px;
  height: 31px;
}

.add-flota-icon-btn {
  width: 33px;
  height: 26px;
}

.reactivate-icon-btn {
  width: 23px;
  height: 23px;
}

.info-img-icon-blocked {
  width: 32px;
  height: 33px;
}

.datos-mas {
  display: flex !important;
  align-items: center;
}

.datos-mas > span {
  color: #a5a5a5;
  font-size: 2.3rem;
  text-align: center;
  width: 100%;
}

.datos-map > div > div {
  border-radius: 0.5em;
}

.datos-precios {
  width: -moz-fit-content;
  width: fit-content;
}

.datos-factura {
  text-align: center;
  width: 100%;
}

.alert.combustible {
  margin-bottom: unset;
  width: 7.5em;
}

.datos-btn-favorito {
  cursor: pointer;
}

table.datos-vehiculos th {
  border-bottom: none;
  font-size: 1.2em;
  padding-left: 1.4em;
}

table.datos-gasolinera > :not(:first-child) {
  border-top: none;
}

table.datos-gasolinera span.input-group-text {
  border: none;
}

table.datos-gasolinera tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

table.datos-gasolinera td {
  padding-bottom: 1.7em;
  padding-top: 1.7em;
  vertical-align: middle;
}

input[type="radio"] {
  width: 1.3em;
  height: 1.3em;
}

input[type="radio"]:checked {
  background-color: #db0b27;
  border-color: #db0b27;
}

input[type="radio"]:checked:after,
.form-check-input:checked[type="radio"] {
  /* Heres your symbol replacement - this is a tick in Unicode. */
  content: "\\2605" !important;
  color: #fff;
  font-size: 1.2em;
  line-height: 1em;
  text-align: center;
}

.form-check-input:checked[type="radio"] {
  background-image: none;
}

input[type="radio"]:focus {
  border-color: #db0b27;
  box-shadow: none;
}

form.search .input-group {
  /* box-shadow: 10px 20px 40px rgb(191 21 108 / 0.1); */
}

form.search .input-group-text {
  /* border: none; */
  border-radius: 0.5em 0 0 0.5em;
}

form.search input {
  border: none;
  border-radius: 0 0.5em 0.5em 0;
}

.form-check-input[type="radio"] {
  border-radius: 0.3em;
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-select {
  padding-top: 2em;
  padding-left: 1.5em;
}

.form-floating > .form-select {
  padding-top: 1.5em;
}

.alert-blocked {
  display: flex;
  align-items: center;
}

.alert-blocked-icon,
.alert-blocked-text {
  padding: 0 0.5em;
  color: #2b363b80;
}

.alert-blocked-text h6 {
  font-weight: 800;
  font-size: 1.1em;
  margin-bottom: 0;
}

.alert-blocked-text p {
  margin-bottom: 0;
}

.datos-gasolinera-marker-icon {
  width: 27px;
  height: 36px;
}

.data-invoice-icon {
  width: 29px;
  height: 38px;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .datos-vehiculo-list {
    max-height: 70vh;
    height: -moz-fit-content;
    height: fit-content;
    min-height: -moz-fit-content;
    min-height: fit-content;
    overflow-x: hidden;
  }

  h2 {
    font-size: 1.4em;
  }

  .content-section {
    margin-top: 1rem;
    padding-top: 1.5rem;
  }

  .content-section form table.datos-gasolinera {
    margin-top: -3rem;
  }

  .content-section table.datos-vehiculos th {
    font-size: 1em;
  }

  .datos-start,
  .datos-content,
  .datos-end {
    padding: 0.4em;
  }

  .datos-mas {
    display: none !important;
    align-items: center;
  }

  .datos-mas-btns {
    display: flex !important;
    justify-content: space-evenly;
    width: 100%;
    flex-direction: row;
    align-items: center;
  }

  .datos-mas-btns button img:hover {
    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(295deg)
      brightness(95%) contrast(320%);
  }

  .datos-precios {
    width: inherit;
    display: flex;
    flex-wrap: nowrap;
    align-items: baseline;
  }

  .datos-precio-gas {
    display: table-cell !important;
  }

  .datos-precio-gas .alert {
    padding-left: 1.3em;
    padding-right: 1.3em;
    width: -moz-fit-content;
    width: fit-content;
  }

  .datos-precios > div {
    margin-right: 0.5rem;
  }

  .icon-bg {
    padding: 1.17em;
    border-radius: 0.5em;
  }

  .form-group {
    width: 98%;
  }

  form.datos-nuevo-vehiculo .form-group label,
  form.datos-facturacion .form-group label {
    padding-left: 15px;
    padding-top: 15px;
    transition: 0.35s all ease;
  }

  .form-group input,
  .form-group select {
    padding-left: 10px;
  }

  .form-group label {
    padding-left: 5px;
  }

  form.datos-nuevo-vehiculo .form-group input:focus ~ label,
  form.datos-facturacion .form-group input:focus ~ label {
    padding-left: inherit;
    padding-top: 5px;
    transition: 0.35s all ease;
  }

  .form-group input,
  .form-group select {
    height: 3.5em;
    padding-top: 1.8em;
  }

  form.datos-nuevo-vehiculo .form-group input:not(:placeholder-shown) ~ label,
  form.datos-facturacion .form-group input:not(:placeholder-shown) ~ label {
    padding-left: inherit;
    padding-top: 5px;
  }

  form.datos-nuevo-vehiculo .form-group select,
  form.datos-facturacion .form-group select {
    opacity: 0;
  }

  form.datos-nuevo-vehiculo .form-group select.show,
  form.datos-facturacion .form-group select.show {
    transition: 0.55s all ease;
    opacity: 1;
  }

  form.datos-nuevo-vehiculo .form-group select.show ~ label,
  form.datos-facturacion .form-group select.show ~ label {
    padding-top: 5px;
    padding-left: inherit;
  }

  .form-group select:focus {
    padding-top: 1.6em;
  }

  form.datos-facturacion button,
  form.datos-nuevo-vehiculo button,
  .modal-body form button {
    margin: 0 auto;
    min-width: 300px;
    padding-left: 3rem;
    padding-right: 3rem;
    width: -moz-fit-content;
    width: fit-content;
  }

  .form-check-input[type="radio"] {
    border-radius: 4px;
  }

  input[type="radio"] {
    width: 24px;
    height: 24px;
  }

  table.datos-gasolinera input[type="radio"]:checked:after,
  table.datos-gasolinera .form-check-input:checked[type="radio"] {
    font-size: 20px;
    line-height: 23px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/datos/datos.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,+BAA+B;EAC/B,kDAAkD;EAClD,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+DAA+D;EAC/D,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;IACnB,4BAAuB;IAAvB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE;oCACgC;EAClC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;IACb,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".datos-vehiculo-list {\r\n  max-height: 60vh;\r\n  min-height: 30vh;\r\n  height: fit-content;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.datos-vehiculo,\r\n.datos-fav {\r\n  display: flex;\r\n}\r\n\r\n.datos-matricula,\r\n.datos-nom-gas,\r\n.datos-nom-user,\r\n.datos-nom-user-empty {\r\n  font-weight: 600;\r\n}\r\n\r\n.datos-nom-user {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.datos-nom-user-empty {\r\n  text-align: center;\r\n}\r\n\r\n.datos-matricula {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.datos-tipo-vehiculo,\r\n.datos-dir-gas,\r\n.datos-dni-user {\r\n  color: #a098ae;\r\n}\r\n\r\n.datos-prov-gas {\r\n  font-weight: 700;\r\n}\r\n\r\n.datos-start,\r\n.datos-content,\r\n.datos-end {\r\n  align-items: center;\r\n  /* background-color: #fdf4f4; */\r\n  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);\r\n  display: flex;\r\n  padding: 0.8em;\r\n  min-width: 7em;\r\n}\r\n\r\n.datos-start,\r\n.datos-gas {\r\n  border-radius: 20px 0 0 20px;\r\n  display: block;\r\n}\r\n\r\n.datos-gas {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.datos-end {\r\n  border-radius: 0 20px 20px 0;\r\n}\r\n\r\n.datos-mas-btns {\r\n  display: none;\r\n}\r\n\r\n.edit-icon-btn {\r\n  width: 23px;\r\n  height: 23px;\r\n}\r\n\r\n.delete-icon-btn {\r\n  width: 20px;\r\n  height: 31px;\r\n}\r\n\r\n.add-flota-icon-btn {\r\n  width: 33px;\r\n  height: 26px;\r\n}\r\n\r\n.reactivate-icon-btn {\r\n  width: 23px;\r\n  height: 23px;\r\n}\r\n\r\n.info-img-icon-blocked {\r\n  width: 32px;\r\n  height: 33px;\r\n}\r\n\r\n.datos-mas {\r\n  display: flex !important;\r\n  align-items: center;\r\n}\r\n\r\n.datos-mas > span {\r\n  color: #a5a5a5;\r\n  font-size: 2.3rem;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.datos-map > div > div {\r\n  border-radius: 0.5em;\r\n}\r\n\r\n.datos-precios {\r\n  width: fit-content;\r\n}\r\n\r\n.datos-factura {\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.alert.combustible {\r\n  margin-bottom: unset;\r\n  width: 7.5em;\r\n}\r\n\r\n.datos-btn-favorito {\r\n  cursor: pointer;\r\n}\r\n\r\ntable.datos-vehiculos th {\r\n  border-bottom: none;\r\n  font-size: 1.2em;\r\n  padding-left: 1.4em;\r\n}\r\n\r\ntable.datos-gasolinera > :not(:first-child) {\r\n  border-top: none;\r\n}\r\n\r\ntable.datos-gasolinera span.input-group-text {\r\n  border: none;\r\n}\r\n\r\ntable.datos-gasolinera tr {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\r\n}\r\n\r\ntable.datos-gasolinera td {\r\n  padding-bottom: 1.7em;\r\n  padding-top: 1.7em;\r\n  vertical-align: middle;\r\n}\r\n\r\ninput[type=\"radio\"] {\r\n  width: 1.3em;\r\n  height: 1.3em;\r\n}\r\n\r\ninput[type=\"radio\"]:checked {\r\n  background-color: #db0b27;\r\n  border-color: #db0b27;\r\n}\r\n\r\ninput[type=\"radio\"]:checked:after,\r\n.form-check-input:checked[type=\"radio\"] {\r\n  /* Heres your symbol replacement - this is a tick in Unicode. */\r\n  content: \"\\2605\" !important;\r\n  color: #fff;\r\n  font-size: 1.2em;\r\n  line-height: 1em;\r\n  text-align: center;\r\n}\r\n\r\n.form-check-input:checked[type=\"radio\"] {\r\n  background-image: none;\r\n}\r\n\r\ninput[type=\"radio\"]:focus {\r\n  border-color: #db0b27;\r\n  box-shadow: none;\r\n}\r\n\r\nform.search .input-group {\r\n  /* box-shadow: 10px 20px 40px rgb(191 21 108 / 0.1); */\r\n}\r\n\r\nform.search .input-group-text {\r\n  /* border: none; */\r\n  border-radius: 0.5em 0 0 0.5em;\r\n}\r\n\r\nform.search input {\r\n  border: none;\r\n  border-radius: 0 0.5em 0.5em 0;\r\n}\r\n\r\n.form-check-input[type=\"radio\"] {\r\n  border-radius: 0.3em;\r\n}\r\n\r\n.form-floating > .form-control:focus,\r\n.form-floating > .form-control:not(:placeholder-shown),\r\n.form-floating > .form-select {\r\n  padding-top: 2em;\r\n  padding-left: 1.5em;\r\n}\r\n\r\n.form-floating > .form-select {\r\n  padding-top: 1.5em;\r\n}\r\n\r\n.alert-blocked {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.alert-blocked-icon,\r\n.alert-blocked-text {\r\n  padding: 0 0.5em;\r\n  color: #2b363b80;\r\n}\r\n\r\n.alert-blocked-text h6 {\r\n  font-weight: 800;\r\n  font-size: 1.1em;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.alert-blocked-text p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.datos-gasolinera-marker-icon {\r\n  width: 27px;\r\n  height: 36px;\r\n}\r\n\r\n.data-invoice-icon {\r\n  width: 29px;\r\n  height: 38px;\r\n}\r\n\r\n/* BREAKPOINT TABLETS*/\r\n@media (min-width: 768px) {\r\n}\r\n\r\n/* BREAKPOINT ESCRITORIO */\r\n@media (min-width: 992px) {\r\n  .datos-vehiculo-list {\r\n    max-height: 70vh;\r\n    height: fit-content;\r\n    min-height: fit-content;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 1.4em;\r\n  }\r\n\r\n  .content-section {\r\n    margin-top: 1rem;\r\n    padding-top: 1.5rem;\r\n  }\r\n\r\n  .content-section form table.datos-gasolinera {\r\n    margin-top: -3rem;\r\n  }\r\n\r\n  .content-section table.datos-vehiculos th {\r\n    font-size: 1em;\r\n  }\r\n\r\n  .datos-start,\r\n  .datos-content,\r\n  .datos-end {\r\n    padding: 0.4em;\r\n  }\r\n\r\n  .datos-mas {\r\n    display: none !important;\r\n    align-items: center;\r\n  }\r\n\r\n  .datos-mas-btns {\r\n    display: flex !important;\r\n    justify-content: space-evenly;\r\n    width: 100%;\r\n    flex-direction: row;\r\n    align-items: center;\r\n  }\r\n\r\n  .datos-mas-btns button img:hover {\r\n    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(295deg)\r\n      brightness(95%) contrast(320%);\r\n  }\r\n\r\n  .datos-precios {\r\n    width: inherit;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .datos-precio-gas {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .datos-precio-gas .alert {\r\n    padding-left: 1.3em;\r\n    padding-right: 1.3em;\r\n    width: fit-content;\r\n  }\r\n\r\n  .datos-precios > div {\r\n    margin-right: 0.5rem;\r\n  }\r\n\r\n  .icon-bg {\r\n    padding: 1.17em;\r\n    border-radius: 0.5em;\r\n  }\r\n\r\n  .form-group {\r\n    width: 98%;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group label,\r\n  form.datos-facturacion .form-group label {\r\n    padding-left: 15px;\r\n    padding-top: 15px;\r\n    transition: 0.35s all ease;\r\n  }\r\n\r\n  .form-group input,\r\n  .form-group select {\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .form-group label {\r\n    padding-left: 5px;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group input:focus ~ label,\r\n  form.datos-facturacion .form-group input:focus ~ label {\r\n    padding-left: inherit;\r\n    padding-top: 5px;\r\n    transition: 0.35s all ease;\r\n  }\r\n\r\n  .form-group input,\r\n  .form-group select {\r\n    height: 3.5em;\r\n    padding-top: 1.8em;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group input:not(:placeholder-shown) ~ label,\r\n  form.datos-facturacion .form-group input:not(:placeholder-shown) ~ label {\r\n    padding-left: inherit;\r\n    padding-top: 5px;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group select,\r\n  form.datos-facturacion .form-group select {\r\n    opacity: 0;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group select.show,\r\n  form.datos-facturacion .form-group select.show {\r\n    transition: 0.55s all ease;\r\n    opacity: 1;\r\n  }\r\n\r\n  form.datos-nuevo-vehiculo .form-group select.show ~ label,\r\n  form.datos-facturacion .form-group select.show ~ label {\r\n    padding-top: 5px;\r\n    padding-left: inherit;\r\n  }\r\n\r\n  .form-group select:focus {\r\n    padding-top: 1.6em;\r\n  }\r\n\r\n  form.datos-facturacion button,\r\n  form.datos-nuevo-vehiculo button,\r\n  .modal-body form button {\r\n    margin: 0 auto;\r\n    min-width: 300px;\r\n    padding-left: 3rem;\r\n    padding-right: 3rem;\r\n    width: fit-content;\r\n  }\r\n\r\n  .form-check-input[type=\"radio\"] {\r\n    border-radius: 4px;\r\n  }\r\n\r\n  input[type=\"radio\"] {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  table.datos-gasolinera input[type=\"radio\"]:checked:after,\r\n  table.datos-gasolinera .form-check-input:checked[type=\"radio\"] {\r\n    font-size: 20px;\r\n    line-height: 23px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
